import { Quiz } from './quiz'
import { Input } from './input'
import { TextInput } from './textInput'
import { DocumentInput } from './documentInput'
import { YesNoInput } from './yesNoInput'
import { ConfirmationInput } from './confirmationInput'
import { MultipleChoiceInput } from './multipleChoiceInput'
import type { Text } from '../types/form'

export class Step {
    constructor(language: string, stepData?: any, inputData: any = {}) {
        if (stepData) {
            const { quiz, inputs, ...restOfData } = stepData
            Object.assign(this, restOfData)
            this.quiz = quiz?.map((quizData: any) => new Quiz(language, quizData)) || null
            this.inputs =
                inputs?.map((input: any) => {
                    if (input.kind === 'plainText') {
                        return new TextInput(language, input)
                    } else if (input.kind === 'attachment' || input.kind === 'multiAttachment') {
                        return new DocumentInput(language, input, inputData[input.id])
                    } else if (input.kind === 'radioGroup' && input.renderHint === 'yesNo') {
                        return new YesNoInput(language, input)
                    } else if (
                        input.kind === 'checkboxGroup' &&
                        input.renderHint === 'confirmation'
                    ) {
                        return new ConfirmationInput(language, input)
                    }

                    return new MultipleChoiceInput(language, input)
                }) || null
        }
    }

    // @ts-ignore
    _id = crypto.randomUUID()
    _type = 'step' as 'step' | 'prepend-step'
    scoreLimitMedium = null as Maybe<number>
    scoreLimitHigh = null as Maybe<number>
    title = null as Maybe<Text>
    text = null as Maybe<Text>
    quiz = null as Maybe<Quiz[]>
    inputs = null as Maybe<Input[]>
}
